import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-componentdialog',
  imports: [CommonModule,MatButtonModule, TranslateDirective],
  templateUrl: './componentdialog.component.html',
  styleUrl: './componentdialog.component.scss'
})
export class ComponentdialogComponent implements OnInit{

  path:string = '';
  constructor( public dialogRef: MatDialogRef<ComponentdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    
  }

  ngOnInit(): void {
    this.path = this.data.path;
  }

}
